import { IAxiosError } from '@shared/types/AxiosError';
import { useQuery } from '@tanstack/react-query';

import { getAllOnboardingInfo, IOnboardingInfoPayload } from '../services';

export function useGetAllOnboardingInfo() {
  const { data, isLoading, isFetching, error, ...query } = useQuery(
    ['getAllOnboardingInfo'],
    () => getAllOnboardingInfo(),
  );

  return {
    // plans: mock,
    data: data?.data || ({} as IOnboardingInfoPayload),
    isFindingOnboardingInfo: isLoading || isFetching,
    errorFindingOnboardingInfo: error as IAxiosError,
    ...query,
  };
}
